<template>
  <div>
    <div class="d-flex justify-content-between align-item-center mb-3">
      <div class="section-title">
        {{ $t("view") }} {{ $tc("distributor", 1) }} {{ $t("share") }}
        {{ $tc("type", 1) }}
      </div>
      <div>
        <a
          v-if="$can('update', 'Share Type')"
          class="btn-blue"
          @click.prevent.stop="goToRoute"
          >{{ $t("edit") }}</a
        >
        <router-link class="btn-blue" to="distributor-share-type"
          >{{ $tc("distributor", 1) }} {{ $t("share") }} {{ $tc("type", 1) }}
          {{ $tc("list", 2) }}</router-link
        >
      </div>
    </div>

    <div class="all-details-container">
      <div class="col-md-12">
        <div class="row">
          <div class="col-md-12 py-2 border-bottom">
            <div class="row">
              <div class="col-md-3 col-lg-2 col-xl-2">
                {{ $t("sharelabel") }}
              </div>
              <div class="col-md-9 col-lg-10 col-xl-10">
                {{ distributorShareType.dst_label }}
              </div>
            </div>
          </div>

          <div class="col-md-12 py-2 border-bottom">
            <div class="row">
              <div class="col-md-3 col-lg-2 col-xl-2">
                {{ $t("isPercentageValue") }}
              </div>
              <div class="col-md-9 col-lg-10 col-xl-10">
                {{ distributorShareType.dst_is_percentage | activeParse }}
              </div>
            </div>
          </div>

          <div class="col-md-12 py-2 border-bottom">
            <div class="row">
              <div class="col-md-3 col-lg-2 col-xl-2">
                {{ $t("percentgeOf") }}
              </div>
              <div class="col-md-9 col-lg-10 col-xl-10">
                {{ distributorShareType.dst_percentage_of }}
              </div>
            </div>
          </div>

          <div class="col-md-12 py-2 border-bottom">
            <div class="row">
              <div class="col-md-3 col-lg-2 col-xl-2">{{ $t("duration") }}</div>
              <div class="col-md-9 col-lg-10 col-xl-10">
                {{ distributorShareType.dst_duration }}
              </div>
            </div>
          </div>

          <div class="col-md-12 py-2 border-bottom">
            <div class="row">
              <div class="col-md-3 col-lg-2 col-xl-2">
                {{ $t("fixedValueShare") }}
              </div>
              <div class="col-md-9 col-lg-10 col-xl-10">
                {{
                  distributorShareType.dst_fixed_value_to_theatre | activeParse
                }}
              </div>
            </div>
          </div>

          <div class="col-md-12 py-2 border-bottom">
            <div class="row">
              <div class="col-md-3 col-lg-2 col-xl-2">
                {{ $tc("status", 1) }}
              </div>
              <div class="col-md-9 col-lg-10 col-xl-10">
                {{
                  distributorShareType.dst_is_active === "Y"
                    ? $t("active")
                    : $t("active")
                }}
              </div>
            </div>
          </div>

          <div class="col-md-12 py-2 border-bottom">
            <div class="row">
              <div class="col-md-3 col-lg-2 col-xl-2">
                {{ $tc("Description") }}
              </div>
              <div class="col-md-9 col-lg-10 col-xl-10">
                {{ distributorShareType.dst_share_type_description }}
              </div>
            </div>
          </div>

          <div
            v-if="login_user_role_id === 1"
            class="col-md-12 py-2 border-bottom"
          >
            <div class="row">
              <div class="col-md-3 col-lg-2 col-xl-2">
                {{ $t("createdby") }}
              </div>
              <div class="col-md-9 col-lg-10 col-xl-10">
                <span>{{ distributorShareType.created_by }}</span>
              </div>
            </div>
          </div>

          <div
            v-if="login_user_role_id === 1"
            class="col-md-12 py-2 border-bottom"
          >
            <div class="row">
              <div class="col-md-3 col-lg-2 col-xl-2">
                {{ $t("createdat") }}
              </div>
              <div class="col-md-9 col-lg-10 col-xl-10">
                <span class="mr-3">{{
                  distributorShareType.created_at | dateparse
                }}</span>
                <!-- <span>12:05 AM</span> -->
              </div>
            </div>
          </div>

          <div
            v-if="login_user_role_id === 1"
            class="col-md-12 py-2 border-bottom"
          >
            <div class="row">
              <div class="col-md-3 col-lg-2 col-xl-2">
                {{ $t("modifiedby") }}
              </div>
              <div class="col-md-9 col-lg-10 col-xl-10">
                <span>{{ distributorShareType.updated_by }}</span>
              </div>
            </div>
          </div>

          <div v-if="login_user_role_id === 1" class="col-md-12 py-2">
            <div class="row">
              <div class="col-md-3 col-lg-2 col-xl-2">
                {{ $t("modifiedat") }}
              </div>
              <div class="col-md-9 col-lg-10 col-xl-10">
                <span class="mr-3">{{
                  distributorShareType.updated_at | dateparse
                }}</span>
                <!-- <span>12:05 AM</span> -->
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import DistributorService from "@/services/DistributorService";
import MasterService from "@/services/MasterService";

export default {
  data() {
    return {
      login_user_role_id: null,
      // Saif
      distributorShareType: {
        dst_id: null,
        dst_label: null,
        dst_fixed_value_to_theatre: null,
        dst_percentage_of: null,
        dst_is_percentage: null,
        dst_duration: null,
        dst_share_type_description: null,
        dst_is_active: null,
        updated_by: null,
        updated_at: null,
        created_at: null,
        created_by: null,
      },
    };
  },
  beforeMount() {
    const { id } = this.$route.query;
    if (id) {
      this.getEditDistributorList(id);
    } else {
      this.$router.go(-1);
    }
    const { role_id } = this.secureStore.get("USINFO");
    this.login_user_role_id = role_id;
  },
  mounted() {},
  methods: {
    // Saif
    getEditDistributorList: function (dst_id) {
      DistributorService.GetDistributorShareTypeById({ dst_id })
        .then((response) => {
          const { data } = response;
          if (data && data.status && data.Records.length > 0) {
            // this.distributorShareType = data.Records[0];
            let obj = data.Records[0];
            // this.distributorShareType = {
            //   ...obj,
            //   ...this.distributorShareType
            // };

            Object.keys(this.distributorShareType).map((x) => {
              this.distributorShareType[x] = obj[x];
              if (x === "created_by") {
                this.getViewUsersDetails(
                  obj[x],
                  "created_by",
                  "distributorShareType"
                );
              } else if (x === "updated_by") {
                this.getViewUsersDetails(
                  obj[x],
                  "updated_by",
                  "distributorShareType"
                );
              }
            });
          } else {
            this.$toasted.show(
              data.message ||
                "Sorry! Something went wrong. kindly contact your administrator"
            );
          }
        })
        .catch(this._CatchError); //message
    },
    getViewUsersDetails(user_id, fieldvalue, key) {
      this[key][fieldvalue] = "-";
      if (user_id) {
        MasterService.GetUserInfoById({ user_id })
          .then((response) => {
            const { data } = response;
            if (data && data.status && data.Records.length > 0) {
              this[key][fieldvalue] = data.Records[0].user_name;
            } else {
              this.$toasted.show(
                data.message ||
                  "Sorry! Something went wrong. kindly contact your administrator"
              );
            }
          })
          .catch(this._CatchError); //message
      }
    },
    goToRoute: function () {
      this.$router.push({
        path: "/distributor/edit-distributor-share-type",
        query: {
          id: this.distributorShareType.dst_id,
        },
      });
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/Pages/DistributorContainer/DistributorShareTypeComponents/viewDistributorShareType.vue